export const PALETTE = {
  BG: "#f7f8fa", SURFACE: "#ffffff", SUBTLE: "#f1f3f6",
  TEXT: "#1a1d24", MUTED: "#7a828e", BORDER: "#eceef2",
  DIVIDER: "#d0d5dc",   // 주문 목록 메뉴 구분선·Total 선 전용(옅은 BORDER보다 한 단계 진한 회색). 4개 화면 공통 톤 조절 노브

  CHIP_BG: "#f1f3f6", THUMB_BG: "#f0f2f5", NOIMG_BG: "#eef0f3",
  CARD_BG: "#ffffff", CARD_BORDER: "#eceef2",
  SALE: "#e23744", PRICE: "#1a1d24", HEAD: "#1a1d24",
  DANGER: "#d64545",   // 경고/오류 문구·취소 배지 등 위험 색(raw 'red' 대체)
  CARD_RADIUS: 16, CHIP_RADIUS: 999,
  CARD_SHADOW: { shadowColor: "#141820", shadowOpacity: 0.05, shadowRadius: 2, shadowOffset: { width: 0, height: 1 }, elevation: 1 },
  ACCENT: "#db146d",
  RADIUS_SM: 8, RADIUS_MD: 14, RADIUS_LG: 16, RADIUS_PILL: 999,
  QTY_CHIP: "#9AA3AF",
} as const;
